import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React  from "react";
import Loader from '../../../utils/Loader';
import { useAddUploadMocExamResultMutation} from "../../../Services/api";
export default function UploadMocResult(props) {
    const notify = () => '';
    const [addUploadResult,isLoading] = useAddUploadMocExamResultMutation();
    const { register, handleSubmit, formState: { errors }} = useForm();
    const onSubmit = (values,e) => {
        const formData = new FormData();
        formData.append('exam_id', props['id']);
        formData.append('course_id', props['course_id']);
        formData.append('student_id', props['student_id']);
        formData.append('file', values.file[0]);
        formData.append('type', 'course');
       
        ///
        addUploadResult(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Upload Result</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Upload Result</h5>
                        <form onSubmit={handleSubmit(onSubmit)} >
                        
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Result File</label>
                                <div className="col-sm-10">
                                    <input type="file" {...register("file",{required:true})} className="form-control" />
                                    <span className="text-danger">{errors.file?.message}</span>
                                    {errors.file && <span  className="text-danger">Result File is required</span>}
                                </div>
                            </div>
                        
                          <div className="modal-footer">
                                
                                {isLoading.status !='pending' ? 
                                 <>
                                    <button type="submit" className="btn btn-warning">Upload</button>
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                 </>     
                                :
                                <button type="submit" className="btn btn-warning" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}